import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { forkJoin } from 'rxjs';
import { NewsService } from '../../services/NewsService';
import { ResourceService } from '../../services/ResourceService';
import { DealService } from '../../services/DealService';

@Injectable({
  providedIn: 'root'
})
export class HomePageResolverService implements Resolve<any>{

    constructor(private messageservice: NewsService, private resourceservice: ResourceService, private dealservice: DealService) { }

    resolve(route: ActivatedRouteSnapshot) {
    
        return forkJoin([
          this.messageservice.getAllNAINews(),
          this.resourceservice.getNAIBrandAdvertisements(),
          this.resourceservice.getNAISponsorLogos(),       
        ]);
        
    }
}